import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-aggrid',
	templateUrl:'./AgGridPluginPage.html',
	styles: [],
	styleUrls:['./AgGridPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgGridPluginPage
{
	mdContent_60 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>aggrid</artifactId>
</dependency>
\`\`\``;
	mdContent_61 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:aggrid:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_62 = `\`\`\`json
"ag-grid-angular": "^35.0.0"
"ag-grid-community": "^35.0.0"
\`\`\``;
	mdContent_63 = `\`\`\`java
public class OrderGrid extends AgGrid<OrderGrid> {
    public OrderGrid() {
        setHeight("600px")
            .enablePagination(25)
            .enableRowSelection("multiple");

        addColumn(new AgGridColumnDef()
            .setField("orderId")
            .setHeaderName("Order ID")
            .setWidth(100));

        addColumn(new AgGridColumnDef()
            .setField("total")
            .setHeaderName("Total")
            .setCellDataType("number"));
    }
}
\`\`\``;
	mdContent_64 = `\`\`\`java
AgGridOptions<?> options = new AgGridOptions<>();
options.configureRendering()
    .setAnimateRows(true)
    .setCellFlashDuration(500);
options.configurePagination()
    .setPagination(true)
    .setPaginationPageSize(50);
\`\`\``;
	mdContent_65 = `\`\`\`java
public class OrderGrid extends AgGrid<OrderGrid> {
    public OrderGrid() {
        setHeight("600px")
            .enablePagination(25)
            .enableRowSelection("multiple");

        addColumn(new AgGridColumnDef()
            .setField("orderId")
            .setHeaderName("Order ID")
            .setWidth(100));

        addColumn(new AgGridColumnDef()
            .setField("status")
            .setHeaderName("Status")
            .setCellRenderer(StatusBadgeRenderer.class));
    }
}
\`\`\``;
}
